<template>
  <font-awesome-icon
    icon="copy"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

library.add(faCopy)

export default {
  name: 'CoozzyCopyIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-white;
  }
</style>
